import { combineReducers } from "redux";

import storage from "redux-persist/lib/storage";
// slices
import clientslReducer from "./slices/clients";
import usersReducer from "./slices/users";
import trainersReducer from "./slices/trainers";
import generalReducer from "./slices/general";
import departmentsReducer from "./slices/departments";
//
import productsReducer from "./slices/products";
import categoriesReducer from "./slices/categories";
import ordersReducer from "./slices/orders";
import workshopsReducer from "./slices/workshops";
import listingsReducer from "./slices/listings";
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  clients: clientslReducer,
  users: usersReducer,
  trainers: trainersReducer,
  general: generalReducer,
  departments: departmentsReducer,
  products: productsReducer,
  categories: categoriesReducer,
  orders: ordersReducer,
  workshops: workshopsReducer,
  listings: listingsReducer,
});

export { rootPersistConfig, rootReducer };
